<template>
  <div class="login-container">
    <div class="login-weaper">
      <p class="login-tip">ADX 广告平台</p>
      <div class="login-border">
        <div class="login-main demo-dynamic">
          <el-form class="login-form"
                   status-icon
                   :rules="loginRules"
                   ref="loginForm"
                   :model="loginForm"
                   label-width="0"
                   size="small">
            <el-form-item prop="username">

              <el-input size="small"
                        v-model="loginForm.username"
                        auto-complete="off"
                        placeholder="请输入用户名">
                <template #prefix>
                  <i class="iconfont icon-people_fill"/>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input size="small"
                        show-password
                        v-model="loginForm.password"
                        auto-complete="off"
                        placeholder="请输入密码">
                <template #prefix>
                  <i class="iconfont icon-lock_fill"/>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="handleLogin"
                         class="login-submit">登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//环境不同显示的样式不同
if (process.env.NODE_ENV === "development"){
  import('@/styles/login2.scss')
}else if(process.env.NODE_ENV ==="production"){
  import('@/styles/login2.scss')
}else{
  import('@/styles/login.scss')
}

export default {
  name: 'login',
  data () {
    return {
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码长度最少为6位', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.$store.commit('SET_ACCESS_TOKEN', '')
  },
  methods: {
    handleLogin () {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.$store.dispatch('loginByUserName', this.loginForm).then(() => {
            this.$router.push({ path: '/' })
          })
        }
      })
    }
  }
}
</script>
